var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagIconIndia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "18px",
    viewBox: "0 0 28 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landing-Page",
    transform: "translate(-243.000000, -967.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "India-Flag-Icon",
    transform: "translate(243.000000, 967.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 1.90070182e-13,
    y: 0,
    width: 27.4736842,
    height: 18,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,0 L24.4736842,0 C26.1305385,1.167223e-15 27.4736842,1.34314575 27.4736842,3 L27.4736842,6 L27.4736842,6 L1.90070182e-13,6 L1.90070182e-13,3 C1.89867276e-13,1.34314575 1.34314575,3.04359188e-16 3,0 Z",
    id: "Rectangle-Copy-3",
    fill: "#FF9440"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,12 L24.4736842,12 C26.1305385,12 27.4736842,13.3431458 27.4736842,15 L27.4736842,18 L27.4736842,18 L1.90070182e-13,18 L1.90070182e-13,15 C1.89867276e-13,13.3431458 1.34314575,12 3,12 Z",
    id: "Rectangle-Copy-3",
    fill: "#2ECC71",
    transform: "translate(13.736842, 15.000000) scale(1, -1) translate(-13.736842, -15.000000) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#456FEB",
    cx: 14,
    cy: 9,
    r: 3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIconIndia);
export default __webpack_public_path__ + "static/media/flag-icon-india.e8cd0e97a6482b5fec261144b8b72b48.svg";
export { ForwardRef as ReactComponent };